/**
 * Shared station marker & legend configuration for Tabulasi and Dashboard2.
 */
const StationMarkerConfig = (function () {
  const STATUS_CLASS = {
    0: "",
    1: "alert-siaga1",
    2: "alert-siaga2",
    3: "alert-siaga3",
  };

  const TYPES = {
    AWLR: {
      name: "Pos Duga Air",
      markerClass: "awlr-marker",
      hasStatus: true,
      filterValue: "AWLR",
    },
    TMAS: {
      name: "Pos Duga Air",
      markerClass: "awlr-marker",
      hasStatus: true,
      filterValue: "AWLR",
    },
    TMAT: {
      name: "Pos Muka Air Tanah",
      markerClass: "agwlr-marker",
      hasStatus: true,
      filterValue: "AWLR",
    },
    AGWLR: {
      name: "Pos Muka Air Tanah",
      markerClass: "agwlr-marker",
      hasStatus: true,
      filterValue: "AGWLR",
    },
    OW: {
      name: "Pos Observation Well",
      markerClass: "ow-marker",
      hasStatus: false,
      filterValue: "OW",
    },
    ARR: {
      name: "Pos Curah Hujan",
      markerClass: "arr-marker",
      hasStatus: false,
      filterValue: "ARR",
    },
    AWLR_ARR: {
      name: "PDA & PCH",
      markerClass: "awlr-arr-marker",
      hasStatus: true,
      filterValue: "AWLR_ARR",
    },
    AWS: {
      name: "Pos Klimatologi",
      markerClass: "aws-marker",
      hasStatus: false,
      filterValue: "AWS",
    },
    FM: {
      name: "Pos Flow Meter",
      markerClass: "fm-marker",
      hasStatus: false,
      filterValue: "FM",
    },
    VNOTCH: {
      name: "Pos V-Notch",
      markerClass: "vnotch-marker",
      hasStatus: false,
      filterValue: "VNOTCH",
    },
    WQ: {
      name: "Pos Kualitas Air",
      markerClass: "wq-marker",
      hasStatus: false,
      filterValue: "WQ",
    },
    OSP: {
      name: "Pos Open Stand Pipe",
      markerClass: "osp-marker",
      hasStatus: false,
      filterValue: "OSP",
    },
    AVWR: {
      name: "Pos Vibrating Wire",
      markerClass: "avwr-marker",
      hasStatus: false,
      filterValue: "AVWR",
    },
    EWS: {
      name: "Early Warning System",
      markerClass: "ews-marker",
      hasStatus: false,
      filterValue: "EWS",
      showOnMap: false,
    },
  };

  function getTypeConfig(type) {
    if (!type) return null;
    return TYPES[String(type).toUpperCase()] || null;
  }

  function getLegendClass(type) {
    const config = getTypeConfig(type);
    if (!config) return null;
    return `${config.markerClass} me-1`;
  }

  function getMarkerClass(type, status) {
    const config = getTypeConfig(type);
    if (!config) return "default-marker";

    const classes = [config.markerClass];
    if (config.hasStatus) {
      const statusClass = STATUS_CLASS[parseInt(status, 10)];
      if (statusClass) classes.push(statusClass);
    }
    return classes.join(" ").trim();
  }

  function getFilterValue(type) {
    const config = getTypeConfig(type);
    return config ? config.filterValue : type;
  }

  function normalizeFilterTypes(checkedTypes) {
    return checkedTypes.map((type) => getFilterValue(type));
  }

  function resolveDataType(dataType) {
    const normalized = String(dataType || "").toUpperCase();
    if (normalized === "TMAT") {
      return "AGWLR";
    }
    return normalized;
  }

  function shouldShowOnMap(type) {
    const config = getTypeConfig(type);
    if (!config) return true;
    return config.showOnMap !== false;
  }

  function shouldShowMarkerFromData(data) {
    const type = resolveDataType(data.type);
    return shouldShowOnMap(type);
  }

  function getMarkerClassFromData(data) {
    const type = resolveDataType(data.type);
    return getMarkerClass(type, data.status);
  }

  function buildLegendEntry(type) {
    const config = getTypeConfig(type);
    if (!config || config.showOnMap === false) return null;
    return {
      type,
      name: config.name,
      classMarker: getLegendClass(type),
      filterValue: config.filterValue,
    };
  }

  function buildLegendFootnoteHtml() {
    return '<p class="mb-0 mt-2 text-muted small fw-semibold">T = Telemetri</p>';
  }

  return {
    TYPES,
    getTypeConfig,
    getLegendClass,
    getMarkerClass,
    getFilterValue,
    normalizeFilterTypes,
    resolveDataType,
    getMarkerClassFromData,
    shouldShowOnMap,
    shouldShowMarkerFromData,
    buildLegendEntry,
    buildLegendFootnoteHtml,
  };
})();

if (typeof Object.freeze === "function") {
  Object.freeze(StationMarkerConfig);
  Object.freeze(StationMarkerConfig.TYPES);
}
